import { plainToClass } from 'class-transformer';
import {
  API_TITLE_FIND_ALL,
  API_TITLE_FIND_ONE,
  API_TITLE_CREATE,
  API_TITLE_UPDATE,
  API_TITLE_DELETE
} from '../api.routes';
import { BaseApi } from './base.api';
import { TitleDto } from '../dto';
import { FindAllResponse } from '../types';

export class TitleApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<TitleDto>> {
    return this.httpClient
      .get(API_TITLE_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(TitleDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<TitleDto> {
    return this.httpClient
      .get(API_TITLE_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(TitleDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<TitleDto> {
    return this.httpClient.post(API_TITLE_CREATE, data).then(({ data }) => {
      return plainToClass(TitleDto, data);
    });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<TitleDto> {
    return this.httpClient.put(API_TITLE_UPDATE, data).then(({ data }) => {
      return plainToClass(TitleDto, data);
    });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_TITLE_DELETE, {
      pathParams: { uuid }
    });
  }
}
